/**
 * The type of the (redux) action which shows/hides the assistance panel.
 *
 * {
 *     type: TOGGLE_ASSISTANCE_PANEL
 *     visible: boolean
 * }.
 */
export const TOGGLE_ASSISTANCE_PANEL = 'TOGGLE_ASSISTANCE_PANEL';
export const SHOW_ASSISTANCE_PANEL = 'SHOW_ASSISTANCE_PANEL';
export const HIDE_ASSISTANCE_PANEL = 'HIDE_ASSISTANCE_PANEL';
export const ASSISTANCE_BREAKOUT_ROOM_HANDLED = 'ASSISTANCE_BREAKOUT_ROOM_HANDLED';
export const ASSISTANCE_BREAKOUT_ROOM_UNHANDLED = 'ASSISTANCE_BREAKOUT_ROOM_UNHANDLED';
export const SET_PARTICIPANT = 'SET_PARTICIPANT';
